<!-- 辅导设置弹窗 -->
<template>
  <div>
    <zlr-modal v-model="isShow">
      <div class="coach-set">
        <h1>文书修改顺序 - {{isSet? '自由支配': '原有次序'}}</h1>
        <ul>
          <li>MSP建议您保持原有的修改顺序，根据再来人的KEIS方法论，原有的修改顺序，能最大程度的帮助到您的修改质量；</li>
          <li>MSP也支持您自由的支配修改顺序，这取决于您自由的选择，但可能由此带来的修改质量下降，是需要您承担的风险；</li>
        </ul>
        <div class="coach-set-prompt">
          注：当您选择“自由支配”后，也可参考原有的文书修改顺序，进行文书修改
        </div>
        <div class="coach-set-btn">
          <Button class="btn btn-close"
                  @click="isShow = false">关闭</Button>
          <Button class="btn btn-sub"
                  :loading="isSub"
                  @click="subHandle">自由支配</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// api
import { setProjectEssayOrder } from '@/api/project'
// componnets
import ZlrModal from '_c/modal/modal'
export default {
  name: 'project-coach-set',
  props: {
    isSet: {
      type: [Boolean],
      default: false
    }
  },
  components: {
    ZlrModal
  },
  data () {
    return {
      isShow: false,
      isSub: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    showHandle () {
      this.isShow = true
    },
    // 自由支配提交
    subHandle () {
      this.isShow = false
      setProjectEssayOrder({}).then(res => {
        this.$zlr_message('选择成功', 'success')
        this.$emit('on-success')
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
